import { render, staticRenderFns } from "./veStuIdxScoreConfig.vue?vue&type=template&id=7ca1d4d4&scoped=true"
import script from "./veStuIdxScoreConfig.vue?vue&type=script&lang=js"
export * from "./veStuIdxScoreConfig.vue?vue&type=script&lang=js"
import style0 from "./veStuIdxScoreConfig.vue?vue&type=style&index=0&id=7ca1d4d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1d4d4",
  null
  
)

export default component.exports